import { List } from 'immutable';

import BaseStore from './BaseStore';
import { STICKET_PHOTOCARD } from '../constants/AppConstants';
import { ActionTypes } from '../constants/AppConstants';


export class PhotocardStore extends BaseStore {

    handleLoaded ({ photocards }) {
        const regularCards = photocards.filter(({ nickname }) => nickname !== STICKET_PHOTOCARD);
        const sTicketCard = photocards.find(({ nickname }) => nickname === STICKET_PHOTOCARD) || null;
        this.setState(this.state.set('cards', regularCards));
        this.setState(this.state.set('sTicketCard', sTicketCard));
        this.emitChange();
    }

    getCards() {
        return this.state.get('cards', new List());
    }

    getSTicketCard() {
        return this.state.get('sTicketCard');
    }

    handleCreated ({ photocard }) {
        const photocards = this.getCards().push(photocard);
        this.handleLoaded({ photocards });
    }

    handleDeleted ({ photocard }) {
        const current = this.getCards();
        const index = current.indexOf(photocard);
        const photocards = current.delete(index);
        this.handleLoaded({ photocards });
    }

    getActionHandlers () {
        return {
            [ActionTypes.PHOTOCARDS_LOADED]: this.handleLoaded,
            [ActionTypes.PHOTOCARD_CREATED]: this.handleCreated,
            [ActionTypes.PHOTOCARD_DELETED]: this.handleDeleted

        };
    }

}

const storeInstance = new PhotocardStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/PhotocardStore.js